module.exports = __webpack_public_path__ + "img/edit-icon.2d40e108.svg";